import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Helmet from 'react-helmet'
import NumberFormat from 'react-number-format'

// Components
import SuggestedProducts from './../SuggestedProducts'
import UpdateQtyCell from './UpdateQtyCell'
import DeleteCell from './DeleteCell'
import TaxRow from './TaxRow'
import Loader from '../utils/Loader'

// State
import { removeCartProduct, removeCartCoupon } from '../../store/actions/cart'
import { getCart } from '../../store/actions/cart'

// CSS
import '../../css/cart.css'
import '../../css/cart-item.css'

class Cart extends Component {
	constructor(props) {
		super(props)
		this.state = {
			shoppertrack: '',
		}
	}

	componentWillReceiveProps(nextProps) {
		// ** Note: I had to use state here and NOT props, because props ended up not changing to nextProps immediately.
		// Why....? WHO KNOWS!
		if (!!nextProps.cart.shoppertrack && this.state.shoppertrack !== nextProps.cart.shoppertrack) {
			this.setState(
				{
					shoppertrack: nextProps.cart.shoppertrack,
				},
				() => this.props.getCart()
			)
		}
	}

	render() {
		const items = this.props.cart.items ? this.props.cart.items : []
		const codes = this.props.cart.codes ? this.props.cart.codes : []
		const donation = this.props.cart.donation ? this.props.cart.donation : []

		let title = 'Cart'
		if (this.props.siteInfo.site) {
			title = this.props.siteInfo.site.title + ' | Cart'
		}

		const helmet = (
			<Helmet>
				<title>{title}</title>
			</Helmet>
		)

		// Set up tax section
		let taxRows = null
		if (this.props.cart.taxes) {
			taxRows = Object.keys(this.props.cart.taxes).map(tax_type => {
				const tax = this.props.cart.taxes[tax_type]
				if (tax > 0 && tax_type !== 'total') {
					return <TaxRow key={tax_type} tax_type={tax_type} tax={tax} />
				} else {
					return null
				}
			})
		}

		return (
			<div className='body_container pt2 pb2'>
				{helmet}

				<main className='product_section'>
					<h1>Cart</h1>

					{this.props.cartLoading ? (
						<div className='pt2 pb2'>
							<Loader />
						</div>
					) : (
						<Fragment>
							{items.length ? (
								<div className='cart-summary'>
									<table className='cart'>
										<thead>
											<tr>
												<th>Product</th>
												<th>Sku</th>
												<th>Price</th>
												<th className='qty-cell'>Qty</th>
												<th>Total</th>
												<th className='delete-cell' />
											</tr>
										</thead>
										<tbody>
											{items.map(item => {
												return (
													<tr key={item.id} className='cart-item'>
														<td className='cart-summary-item'>
															<div className='item-title'>
																<Link
																	to={`/${item.categories[0].permalink}/product/${item.permalink}`}
																>
																	{item.title}
																</Link>
															</div>
															{item.variant && (
																<div className='line-item'>
																	<span className='line-title'>{item.variant.title}</span>
																</div>
															)}
															{item.shipping_exempt !== 0 && (
																<React.Fragment>
																	<div className='order-info--pickup-note'>
																		* item is a pickup product.
																	</div>
																	{console.log('item.is_pickup:', item.shipping_exempt)}
																	{console.log(item.is_pickup)}
																</React.Fragment>
															)}
														</td>
														<td>
															<div>{item.sku}</div>
															{item.top_tier_discounted === 1 && (
																<div className='cart_member_label'>{'Member Price'}</div>
															)}
														</td>
														<td>
															<div>
																<NumberFormat
																	value={
																		item.top_tier_discounted === 0
																			? item.price_final
																			: item.top_tier_original
																	}
																	style={
																		item.top_tier_discounted === 0
																			? {}
																			: { textDecoration: 'line-through' }
																	}
																	displayType={'text'}
																	decimalScale={2}
																	fixedDecimalScale={true}
																	thousandSeparator={true}
																	prefix={'$'}
																/>
															</div>
															{item.top_tier_discounted === 1 && (
																<div className='cart_member_price'>
																	<NumberFormat
																		value={item.price}
																		displayType={'text'}
																		decimalScale={2}
																		fixedDecimalScale={true}
																		thousandSeparator={true}
																		prefix={'$'}
																	/>
																</div>
															)}
														</td>
														<td className='qty-cell'>
															<UpdateQtyCell product={item} />
														</td>
														<td>
															<div>
																<NumberFormat
																	value={
																		item.top_tier_discounted === 0
																			? item.total
																			: item.top_tier_original * item.qty
																	}
																	style={
																		item.top_tier_discounted === 0
																			? {}
																			: { textDecoration: 'line-through' }
																	}
																	displayType={'text'}
																	decimalScale={2}
																	fixedDecimalScale={true}
																	thousandSeparator={true}
																	prefix={'$'}
																/>
															</div>
															{item.top_tier_discounted === 1 && (
																<div className='cart_member_price'>
																	<NumberFormat
																		value={item.total}
																		displayType={'text'}
																		decimalScale={2}
																		fixedDecimalScale={true}
																		thousandSeparator={true}
																		prefix={'$'}
																	/>
																</div>
															)}
														</td>
														<td className='delete-cell'>
															<DeleteCell type={'product'} item={item} />
														</td>
													</tr>
												)
											})}
											{codes.map((code, i) => {
												if (code.code_type === 'general') {
													return (
														<tr key={i} className='cart-item coupon-item'>
															<td>
																<div className='coupon-item-title'>{code.code}</div>
																<div>Coupon</div>
															</td>
															<td />
															<td />
															<td className='qty-cell' />
															<td>
																<NumberFormat
																	value={code.value}
																	displayType={'text'}
																	decimalScale={2}
																	fixedDecimalScale={true}
																	thousandSeparator={true}
																	prefix={code.sale_type === 'dollar' ? '$' : ''}
																	suffix={code.sale_type === 'percentage' ? '%' : ''}
																/>
															</td>
															<td className='delete-cell'>
																<DeleteCell type={'coupon'} item={code} />
																{/* <div className="ajax-msg delete" /> */}
																{/* <div className="icon-cross delete-btn delete-coupon-item" /> */}
															</td>
														</tr>
													)
												} else {
													return (
														<tr key={i} className='cart-item coupon-item'>
															<td colSpan='5'>
																<div className='coupon-item-title'>
																	{'Coupon (' + code.code + ')'}
																</div>
																<div>{code.message}</div>
															</td>
															<td className='delete-cell'>
																<DeleteCell type={'coupon'} item={code} />
																{/* <div className="ajax-msg delete" /> */}
																{/* <div className="icon-cross delete-btn delete-coupon-item" /> */}
															</td>
														</tr>
													)
												}
											})}
											{this.props.cart.shipping && (
												<tr className='cart-item value-row'>
													<td colSpan='4'>
														<div>Shipping</div>
														<div>{this.props.cart.shipping.title}</div>
													</td>
													<td>
														<NumberFormat
															value={this.props.cart.shipping.cost}
															displayType={'text'}
															decimalScale={2}
															fixedDecimalScale={true}
															thousandSeparator={true}
															prefix={'$'}
														/>
													</td>
													<td className='delete-cell' />
												</tr>
											)}
											{taxRows}
											{donation.map((donation, i) => {
												return (
													<tr key={i} className='cart-item value-row donation'>
														<td>
															<div className='donation-item-title'>Donation</div>
														</td>
														<td colSpan='3'>{donation.charity}</td>
														<td>
															<NumberFormat
																value={donation.amount}
																displayType={'text'}
																decimalScale={2}
																fixedDecimalScale={true}
																thousandSeparator={true}
																prefix={'$'}
															/>
														</td>
														<td className='delete-cell'>
															<DeleteCell type={'donation'} item={donation} />
														</td>
													</tr>
												)
											})}
										</tbody>
										<tfoot>
											<tr>
												<th colSpan='4'>Total:</th>
												<th className='qty-cell' data-hbs-id='cart-total'>
													<div className='hbs-cart-total'>
														<NumberFormat
															value={this.props.cart.total}
															displayType={'text'}
															decimalScale={2}
															fixedDecimalScale={true}
															thousandSeparator={true}
															prefix={'$'}
														/>
													</div>
												</th>
												<th className='delete-cell' />
											</tr>
										</tfoot>
									</table>

									<Link className='btn btn--red btn--continue' to={`/checkout`}>
										Continue to checkout
									</Link>
								</div>
							) : (
								<div>You do not have any items in your shopping cart!</div>
							)}
						</Fragment>
					)}
				</main>
				<SuggestedProducts />
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo,
		cart: state.cart,
		cartLoading: state.cart.loading,
	}
}

export default connect(mapStateToProps, { removeCartProduct, removeCartCoupon, getCart })(Cart)



// WEBPACK FOOTER //
// ./src/components/cart/Cart.js